/* eslint-disable import/no-anonymous-default-export */

/**
 * Tipos de usuário do sistema.
 *
 * IMPORTANTE: os códigos (`code`) estão alinhados com o back-end
 * (api/app/enums/EUserTypes.js), que é a fonte da verdade para o banco.
 * Antes os códigos do front estavam divergentes do back; agora batem.
 */
const EUserTypes = {
  EMPLOYEE: {
    code: 0,
    description: 'Colaborador',
    label: 'Funcionário'
  },
  CLIENT_ADMIN: {
    code: 1,
    description: 'Administrador',
    label: 'Admin Cliente'
  },
  ORIGINAL_CLIENT: {
    code: 2,
    description: 'Cliente Original',
    label: 'Cliente'
  },
  PANEL_ADMIN: {
    code: 3,
    description: 'Administrador Painel Web',
    label: 'Admin'
  },
  OPERADOR: {
    code: 4,
    description: 'Operador',
    label: 'Operador'
  },
  OPERADOR_COMPRADOR: {
    code: 5,
    description: 'Operador Comprador',
    label: 'Operador Comprador'
  },
  LIDER: {
    code: 6,
    description: 'Líder',
    label: 'Líder'
  },
};

// Grupos auxiliares (espelham o back-end)
EUserTypes.ALL_PANEL_WEB_USERS = { code: [3, 4, 5, 6] }; // Admin, Operador, Operador-comprador, Líder (logam no painel web)
EUserTypes.ALL_OPERATORS = { code: [3, 4, 5, 6] };       // Executam fluxos operacionais

/**
 * Retorna o tipo de usuário a partir do código, ou null.
 * @param {number} code
 */
EUserTypes.getByCode = (code) => {
  return Object.values(EUserTypes).find(t => t && t.code === code) || null;
};

/**
 * Retorna true se o usuário pode corrigir registros operacionais:
 * Admin (sem restrição) ou Operador-comprador/Líder (registros de hoje, com
 * justificativa obrigatória — validada na API). Espelha o TODAY_EDITORS do back.
 * @param {Object} loggedUser Usuário logado ({ type }).
 */
EUserTypes.canEditToday = (loggedUser) => {
  const type = Number(loggedUser?.type);
  return [
    EUserTypes.PANEL_ADMIN.code,
    EUserTypes.OPERADOR_COMPRADOR.code,
    EUserTypes.LIDER.code
  ].includes(type);
};

/**
 * Retorna true se o usuário é Admin do painel (justificativa opcional nas correções).
 * @param {Object} loggedUser Usuário logado ({ type }).
 */
EUserTypes.isPanelAdmin = (loggedUser) => {
  return Number(loggedUser?.type) === EUserTypes.PANEL_ADMIN.code;
};

export default EUserTypes;
